import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner } from 'office-ui-fabric-react/lib/components/Spinner';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { Label } from 'reactstrap';
import { IAgentCharges } from '../../../models/IAgentCharges';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import { IAgentChargesPreviewProps } from './IAgentChargesPreviewProps';
import { IAgentChargesPreviewState } from './IAgentChargesPreviewState';
initializeIcons();
const topPanel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const topMsgPanel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 1px 1px #C9C9C9',
    borderRadius: "5px",
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const alertMsgPanel = mergeStyles({
    color: "#E9512D", fontSize: "13px", textAlign: "left"
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTableContent = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    border: "1px solid #005269"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #F39000",
    backgroundColor: '#F39000', color: "#ffffff"

});
const responsiveTableHeaderCell = mergeStyles({
    textAlign: "center", backgroundColor: "#35AFD1", color: "#FFFFFF", width: "100%", padding: "5px"
});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle"
});
const responsiveTableBodyCellParticulars = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle",
    width: "40%"
});
const responsiveTableBodyCellRight = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "right"
});
const textAlignRight = mergeStyles({
    textAlign: "right"
});
const submitButton = mergeStyles({ backgroundColor: '#005269', marginRight: "5px" });
const cancelButton = mergeStyles({ backgroundColor: '#E9512D', marginRight: "5px" });
export interface IDetailsListGroupedItem {
    key: number;
    particulars: string;
    officialfee: number;
    professionalfee: number;
    otherexpenses: number
    total: number;
    notapplicable: boolean;
}
export default class AgentChargesPreview extends React.Component<IAgentChargesPreviewProps, IAgentChargesPreviewState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private saving: boolean = false;

    constructor(props: IAgentChargesPreviewProps, state: IAgentChargesPreviewState) {
        super(props);
        this.connectionContext = this.props.connectionContext;

        this.state = {
            loading: false,
            inputError: 'This field is required',
            showError: false,
            isValidData: true,
            Countries: [],
            hideErrorDialog: true,
            agentCharges: [],
            selectedCountry: this.props.selectedCountry,
            selectedcountries: this.props.selectedcountries,
            hideSuccessDialog: true,
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async componentDidMount() {
        if (this.props.agentCharges.length > 0) {
            this.setState((prevState: IAgentChargesPreviewState): IAgentChargesPreviewState => {
                prevState.agentCharges = this.props.agentCharges;
                prevState.agentCharges.forEach((item: IAgentCharges) => {
                    item.notApplicable = (item.total > 0 ? false : true);
                });
                return prevState;
            });
        }
    }
    public render(): React.ReactElement<IAgentChargesPreviewProps> {
        const trademarkitems = this.state.agentCharges.filter(tech => tech.category === "TRADE MARK");
        const patentsitems = this.state.agentCharges.filter(tech => tech.category === "PATENTS");
        const designitems = this.state.agentCharges.filter(tech => tech.category === "DESIGN");
        const hourlyrateitems = this.state.agentCharges.filter(tech => tech.category === "HOURLY RATE PROSECUTION");

        return (
            <div className={topPanel}>
                {
                    (!this.saving) && (
                        <div className={responsiveTableHeaderCell}>
                            <h6>Preview</h6>
                        </div>)
                }
                {
                    (this.saving) && (
                        <div>
                            <div>
                                <Spinner label="Please wait..." />
                            </div>
                        </div>)
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideErrorDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <Label> {this.dialog.dialogBody} </Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.closeModelPopUp} className={submitButton} data-automation-id="test" text="Ok" disabled={false} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideSuccessDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Close"
                            >
                                <div>
                                    <div>
                                        <Label> Agent fee for <strong> {this.state.selectedCountry} </strong> is successfully submitted. Please select another jurisdiction, if any, from the list and enter the charges.</Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <PrimaryButton onClick={this.props.onClose} data-automation-id="test" text="Ok" className={submitButton} iconProps={{ iconName: 'CompletedSolid' }} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
                {
                    (!this.saving) && (
                        <div>
                            <div>
                                <div className={topMsgPanel}>You have chosen <strong>{this.state.selectedcountries}</strong> as your service available jurisdiction <br />
                                    Now you are viewing charges for : <strong>{this.state.selectedCountry}</strong>
                                </div>
                                <div>
                                    <Separator></Separator>
                                    <h6>TRADE MARK</h6>
                                    <div className={responsiveMain}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableHeaderRow}>
                                                    <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Official fee (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Professional fee (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Other fee (if applicable) (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                </div>
                                                {
                                                    trademarkitems.map((tech, i) => {
                                                        return (
                                                            <div className={responsiveTableRow}>
                                                                <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.officialfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.professionalfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.otherexpenses}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.total}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p><input type="checkbox" value={tech.particulars} checked={trademarkitems[i].notApplicable} disabled /></p></div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <Separator></Separator>
                                    <h6>PATENTS</h6>
                                    <div className={responsiveMain}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableHeaderRow}>
                                                    <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Official fee (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Professional fee (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Other fee (if applicable) (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                </div>
                                                {
                                                    patentsitems.map((tech, i) => {
                                                        return (
                                                            <div className={responsiveTableRow}>
                                                                <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.officialfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.professionalfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.otherexpenses}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.total}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p><input type="checkbox" value={tech.particulars} checked={patentsitems[i].notApplicable} disabled /></p></div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <Separator></Separator>
                                    <h6>DESIGN</h6>
                                    <div className={responsiveMain}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableHeaderRow}>
                                                    <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Official fee (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Professional fee (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Other fee (if applicable) (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                </div>
                                                {
                                                    designitems.map((tech, i) => {
                                                        return (
                                                            <div className={responsiveTableRow}>
                                                                <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.officialfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.professionalfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.otherexpenses}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.total}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p><input type="checkbox" value={tech.particulars} checked={designitems[i].notApplicable} disabled /></p></div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <Separator></Separator>
                                    <h6>HOURLY RATE PROSECUTION</h6>
                                    <div className={responsiveMain}>
                                        <div className={responsiveTableContent}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableHeaderRow}>
                                                    <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Paralegal level (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Associate level (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Partner level (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                    <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                </div>
                                                {
                                                    hourlyrateitems.map((tech, i) => {
                                                        return (
                                                            <div className={responsiveTableRow}>
                                                                <div className={responsiveTableBodyCell}><p>{tech.particulars}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.officialfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.professionalfee}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.otherexpenses}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p>{tech.total}</p></div>
                                                                <div className={responsiveTableBodyCellRight}><p><input type="checkbox" value={tech.particulars} checked={hourlyrateitems[i].notApplicable} disabled /></p></div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={alertMsgPanel}>Please make sure you have entered the correct values before submitting. Once submitted, it cannot be modified.
                                In future, if there is any correction in the charges, please contact agent.network@zacco.com.
                            </div>
                            <div>
                                <PrimaryButton text="Submit" data-automation-id="test" onClick={this.submitForm.bind(this)} className={submitButton} iconProps={{ iconName: 'SaveAndClose' }} />
                                <PrimaryButton text="Corrections?" data-automation-id="test" onClick={this.props.onCancel} className={cancelButton} iconProps={{ iconName: 'Edit' }} />
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private submitForm = async (): Promise<void> => {
        try {
            this.saving = true;
            await this.connectionContext.post("AgentCharges", this.state.agentCharges);
            this.setState((prevState: IAgentChargesPreviewState): IAgentChargesPreviewState => {
                prevState.isValidData = true;
                prevState.hideSuccessDialog = false;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private closeModelPopUp = () => {
        this.setState((previousState: IAgentChargesPreviewState, props: IAgentChargesPreviewProps): IAgentChargesPreviewState => {
            previousState.hideErrorDialog = true;
            this.saving = false;
            return previousState;
        });
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentChargesPreviewState, props: IAgentChargesPreviewProps): IAgentChargesPreviewState => {
            previousState.hideErrorDialog = false;
            return previousState;
        });
    }
}